import {createSlice} from '@reduxjs/toolkit';
import {batch} from 'react-redux'
import BetServices from '../services/BetServices';
import BetslipAction from '../actions/BetslipAction';
import BetslipHelper from '../components/CompactView/LeftSideBarComponent/BetslipComponent/BetslipHelper';
import Constants from '../common/Constants';
import {openAlert} from './AlertSlice';
import {changeButton} from './SidebarSelectedDataSlice';
import BetslipCommon from '../common/BetslipCommon';
import {BETSLIP_TABS, OddsFormat, RoundRobinOption, WagerMyBetMap, WinRiskType} from '../common/Foundation';
import { wagerMap, wagerSelectionMap } from '../components/CompactView/LeftSideBarComponent/PendingBetsComponent/constants';
import {
  reloadBalanceAndPendingBets,
  resetAttentionState,
  setIsInPlaceBetProcess,
  setIsReuseSelection,
  updateAttentionState,
  updateConfirmationRemoveState,
  updateCurrentOddsFormatState,
  updateLoadingState,
  updateMinMaxBetState,
  updateOddsSelectionState,
  updatePitchersState,
  updatePlaceBetInfo,
  updatePlaceSingleBetsSuccessState,
  updateShowAttentionState,
  updateSingleBetsState,
  updateStakeInputsState
} from './BetslipSlice';
import {EVENT} from '../events/listEvents';
import {
  postMessageToHRIframe,
  updateHRBetslipItems,
  updateCurrentOddsFormatState as updateRBCurrentOddsFormatState,
  updateSingleBetsState as updateHRSingleBetsState,
} from './HRBetslipSlice';
import _ from 'lodash';
import {GA4Common, GA_EVENT} from "../common/GA4Common";

const EMPTY_OBJECT = {}
const EMPTY_ARRAY = []
const EMPTY_VALUE = ''

const initialState = {
  parlayOddsRequest: EMPTY_OBJECT,
  parlayBets: EMPTY_OBJECT,
  parlayStake: '',
  invalidStake: false,
  selectedRROs: [RoundRobinOption.PARLAY],
  parlayBetsSucessRes: EMPTY_OBJECT,
  parlayAcceptBetterOdds: BetslipHelper.loadDefaultAcceptBetterOdds()
}

export const ParlayBetslipSlice = createSlice({
    name: 'ParlayBetslipSlice',
    initialState: initialState,
    reducers: {
      updateParlayBetsState: (state, {payload}) => {
        //store data after call service get odds selection
        state.parlayBets = payload
      },
      pushNewHRParlayBetItem: (state, {payload}) => {
        if (state.parlayBets.legs) {
          state.parlayBets.legs.push(payload);
        } else {
          state.parlayBets.legs = [payload];
        }
      },
      updateNewHRParlayLegs: (state, {payload}) => {
        state.parlayBets.legs = payload;
      },
      updateHRParlayLeg: (state, {payload}) => {
        if (payload) {
          const {
            oddsId,
            oldDisplayOdds,
            oddsDisplay,
            odds,
            status,
            betSlipEmit,
            limit, 
            winAmount, 
            riskAmount
          } = payload;
          if (state.parlayBets.legs) {
            for (const bet of state.parlayBets.legs) {
              if (oddsId === bet.oddsId) {
                if(oldDisplayOdds) {
                  bet.oldDisplayOdds = oldDisplayOdds;
                }
                bet.oddsDisplay = oddsDisplay;
                bet.odds = odds;
                if(status) {
                  bet.status = status;
                }
                bet.betSlipEmit = betSlipEmit;
                bet.limit = limit;
                bet.winAmount = winAmount;
                bet.riskAmount = riskAmount;
              }
            }
          }
        }
      },
      updateMinMaxHRParlayBet: (state, {payload}) => {
        const {minRiskStake, minWinStake, maxRiskStake, maxWinStake, odds, totalOdds} = payload;
        state.parlayBets = {
          ...state.parlayBets,
          minRiskStake,
          minWinStake,
          maxRiskStake,
          maxWinStake,
          odds,
          totalOdds,
          roundRobinOptions: [{...state.parlayBets.roundRobinOptions[0], odds, totalOdds}],
        }
      },
      updateHRParlayTotalOdds: (state, {payload}) => {
        const { odds, totalOdds} = payload;
        state.parlayBets = {
          ...state.parlayBets,
          odds,
          roundRobinOptions: [{...state.parlayBets.roundRobinOptions[0], odds, totalOdds}],
        }
      },
      updateParlayOddsRequestState: (state, {payload}) => {
        state.parlayOddsRequest = payload
      },
      updateParlayStakeState: (state, {payload}) => {
        state.parlayStake = payload
      },
      updateSelectedRROsState: (state, {payload}) => {
        state.selectedRROs = payload
      },
      updateParlayBetSuccessResState: (state, {payload}) => {
        state.parlayBetsSucessRes = payload
      },
      updatePlaceParlayBetsSuccessState: state => {
        state.parlayBets = []
        state.selectedRROs = [RoundRobinOption.PARLAY]
        state.parlayStake = EMPTY_VALUE
       },
       updatePitcherParlaySuccess: state => {
        state.hasErrorUpdatePitcher = false
      },
      updatePitcherParlayFailure: state => {
        state.hasErrorUpdatePitcher = true
      },
      updateParlayAcceptBetterOddsState: (state, {payload}) => {
        state.parlayAcceptBetterOdds = payload
      },
      updateInvalidStake: (state, {payload}) => {
        state.invalidStake = payload
      }
    }
  });
  
  export const {
    updateParlayBetsState,
    pushNewHRParlayBetItem,
    updateNewHRParlayLegs,
    updateHRParlayLeg,
    updateMinMaxHRParlayBet,
    updateHRParlayTotalOdds,
    updateParlayOddsRequestState,
    updateParlayStakeState,
    updateSelectedRROsState,
    updateParlayBetSuccessResState,
    updatePlaceParlayBetsSuccessState,
    updatePitcherParlaySuccess,
    updatePitcherParlayFailure,
    updateParlayAcceptBetterOddsState,
    updateInvalidStake
  } = ParlayBetslipSlice.actions

  /** HANDLE BUSSINESS LOGIC */
  export const fetchParlayOddsSelectionInfo = () => {
    return async (dispatch, getState) => {
      const { oddsSelection, attention, selectedBetslipTab } = getState().BetslipSlice
      const { parlayBetsSucessRes } = getState().ParlayBetslipSlice
      if (oddsSelection.length > 0) {
        const { oddsFormat }  = getState().SportsSlice.options
        const payload = BetslipHelper.buildParlayOddsSelectionRequest(oddsSelection, oddsFormat)
        const { parlayOddsSelections } = payload.parlayOddsRequest
		// don't call service if betslip contain only outright bet
        if (parlayOddsSelections.length === 0) {
          return
        }
        try {
          dispatch(updateLoadingState(true))
          const response =  await BetServices.parlayOddsSelections(payload).then(res => {
            return res.data;
          }).catch(e => {
    
          });
          if (!BetslipHelper.isDefaultAttention(attention, selectedBetslipTab)) {
            dispatch(updateShowAttentionState(false));
            dispatch(resetAttentionState());
          }
          if (response.error) {
            dispatch(openAlert({
              message: 'errors:'+ response.error
            }))
          
            return;
          }
          batch(() => {
            if (Object.keys(parlayBetsSucessRes).length > 0) {
              dispatch(updateParlayBetSuccessResState(EMPTY_OBJECT))
            }
            dispatch(updateLoadingState(false))
            dispatch(updateParlayOddsRequestState(payload))
            const updatedRes = JSON.parse(JSON.stringify(response))
            updatedRes.legs = BetslipHelper.addPropsToLegs(
              oddsSelection, 
              payload, 
              updatedRes.legs, 
              ['eventDate', 'parlayRestriction']
            );
            const parlayBets = getState().ParlayBetslipSlice.parlayBets;
            const rbParlayLegs = parlayBets.legs && parlayBets.legs.filter(bet => bet.sportId === Constants.HORSE_RACING_ID);
            if (BetslipHelper.isOddsChangeOnLegs(response.legs)) {
              updatedRes.legs = BetslipHelper.addOldOddsForLegs(oddsSelection, payload, updatedRes.legs)
            }
            if(rbParlayLegs && rbParlayLegs.length > 0) {
              dispatch(updateParlayBetsState({...updatedRes, legs: [...updatedRes.legs, ...rbParlayLegs]}))
            } else {
              dispatch(updateParlayBetsState(updatedRes))
            }
            dispatch(updateCurrentOddsFormatState(oddsFormat))
          })
          window.fireEvent(EVENT.SCROLL_TO_BOTTOM_AFTER_ADD_BET)
         
        } catch (error) {
          dispatch(updateLoadingState(false))
        }
      } else {
        batch(() => {
          dispatch(updateParlayBetsState(EMPTY_OBJECT))
          dispatch(updateParlayOddsRequestState(EMPTY_OBJECT))
          dispatch(updateSingleBetsState(EMPTY_ARRAY))
        })
        
      }
    }
  }
  
  export const executePlaceParlayBets = () => {
    return async (dispatch, getState) => {
      const {
        parlayStake,
        selectedRROs,
        parlayBets,
        parlayAcceptBetterOdds,
      } = getState().ParlayBetslipSlice;

      const {
        betCredit:currentBalance
      }=getState().AccountsSlice.user;
  
      const { 
        oddsFormat 
      } = getState().SportsSlice.options;
      const {oddsSelection, attention, selectedBetslipTab} = getState().BetslipSlice;
      const payload = BetslipHelper.buildParlayBetPayload(parlayBets.ticketId, parlayStake, oddsFormat, parlayAcceptBetterOdds, selectedRROs.length === 0 ? [RoundRobinOption.PARLAY] : selectedRROs)
      try {
        // reset attention if it is not default
        if (!BetslipHelper.isDefaultAttention(attention, selectedBetslipTab)) {
          dispatch(updateShowAttentionState(false));
          dispatch(resetAttentionState());
        }
        dispatch(updateLoadingState(true))
        dispatch(setIsInPlaceBetProcess(true));
        const res = await BetServices.postPlaceParlayBetAPI(payload, BetslipCommon.generateUUID()).then(res => {
          return res
        }).catch(e => {
          dispatch(openAlert({
            message: 'errors:' + Constants.BET_ERROR_CODE.INTERNAL_ERROR
          }))
          dispatch(setIsInPlaceBetProcess(false));
        });
        dispatch(updateLoadingState(false))
        dispatch(setIsInPlaceBetProcess(false));
        if (!res) {
          dispatch(openAlert({
            message: 'errors:'+Constants.BET_ERROR_CODE.INTERNAL_ERROR
          }))
          return
        }
  
        const { errorCode, response, errorMessage } = res.data
        if (errorCode) {
          if (errorCode === Constants.BET_ERROR_CODE.RESPONSIBLE_LIMIT_EXCEEDED_RISK || errorCode === Constants.BET_ERROR_CODE.RESPONSIBLE_LIMIT_EXCEEDED_LOSS) {
            dispatch(updateParlayStakeState(errorMessage))
          }
          let tmp = {
            message: 'errors:'+ errorCode,
          }
          
          if (errorCode === Constants.BET_ERROR_CODE.INVALID_ROUND_ROBIN_OPTIONS) {
            tmp.message = 'errors:'+ Constants.BET_ERROR_CODE.MINIMUM_ROUND_ROBIN_OPTIONS
          }
          if (errorCode === Constants.BET_ERROR_CODE.BETTING_BUDGET_EXCEEDED) {
              tmp.params = [errorMessage]
          }
          dispatch(openAlert(tmp))
          GA4Common.sendEventGA(GA_EVENT.BET_SLIP, {errorCode, currentBalance});
          return
        }
        const singleSelection = oddsSelection.filter((item) => {
          return !BetslipHelper.isAllowParlay(item);
        });

        const status = response[0].status;
        if ([Constants.BET_STATUS.PENDING_ACCEPTANCE, Constants.BET_STATUS.ACCEPTED].includes(status)) {
          const parlayBetSuccessRes = JSON.parse(JSON.stringify(parlayBets))
          const { roundRobinOptions } = parlayBetSuccessRes;
          const bets = [Constants.BET_STATUS.ACCEPTED].includes(status)
            ? selectedRROs.map(rro => {
              const rroDetail = roundRobinOptions.filter(r => r.roundRobinOption === rro)[0] || {};
              const acceptedBets = response.filter(bet => bet.parlayBet.legs.length === rroDetail.rroLegs);
              if (acceptedBets.length > 0) {
                return acceptedBets.length === 1
                  ? {
                      betId: acceptedBets[0].betId,
                      win: acceptedBets[0].parlayBet.win,
                      risk: acceptedBets[0].parlayBet.risk,
                      roundRobinOption: rro
                    }
                  : {
                      betId: acceptedBets[0].betId,
                      win: acceptedBets.reduce((totalWin, bet) => { return totalWin + bet.parlayBet.win }, 0),
                      risk: acceptedBets.reduce((totalRisk, bet) => { return totalRisk + bet.parlayBet.risk }, 0),
                      originRisk : acceptedBets[0].parlayBet.risk,
                      roundRobinOption: rro
                    }
              }
              return null;
            }).filter(bet => bet)
          : selectedRROs.map(rro => {
              const rroDetail = roundRobinOptions.filter(r => r.roundRobinOption === rro)[0] || {};
              return {
                betId: response[0].betId,
                roundRobinOption: rro,
                rroLegs: rroDetail.rroLegs,
                status: Constants.BET_STATUS.PENDING_ACCEPTANCE
              }
            });

          parlayBetSuccessRes[
            [Constants.BET_STATUS.ACCEPTED].includes(status)
              ? 'acceptedBets'
              : 'pendingBets'
          ] = bets;
          parlayBetSuccessRes.status = status;
          parlayBetSuccessRes.isRBParlay = false;
          GA4Common.sendEventGA(GA_EVENT.BET_SLIP, {errorCode, currentBalance});
          batch(() => {
            dispatch(updateParlayBetSuccessResState(parlayBetSuccessRes));
            dispatch(updatePlaceSingleBetsSuccessState(singleSelection));
            dispatch(updatePlaceParlayBetsSuccessState());
            dispatch(setIsReuseSelection(false));
          });
          reloadBalanceAndPendingBets();
        } else if (status === Constants.BET_STATUS.PROCESSED_WITH_ERROR) {
          dispatch(handlePlaceBetError(response[0]));
          GA4Common.sendEventGA(GA_EVENT.BET_SLIP, {errorCode, currentBalance});
        }
      } catch (error) {
        GA4Common.sendEventGA(GA_EVENT.BET_SLIP, {errorCode:Constants.BET_ERROR_CODE.INTERNAL_ERROR, currentBalance});
      }
    }
  }

const handlePlaceBetError = (response) => {
  return (dispatch, getState) => {
    const { invalidLegs, validLegs, roundRobinOptionWithOdds, errorCode } = response;
    const parlayBets = JSON.parse(JSON.stringify(getState().ParlayBetslipSlice.parlayBets));
    const { oddsFormat } = getState().SportsSlice.options;
    let attention = {};
    if (_.isEmpty(parlayBets) || _.isEmpty(parlayBets.legs)) return;

    switch (errorCode) {
      case Constants.BET_ERROR_CODE.INVALID_LEGS:
        const lineChangeInfo = {hasLineChange: false};
        updateParlayLegsInfo(invalidLegs, validLegs, parlayBets, lineChangeInfo);
        if (!BetslipHelper.isDisablePlaceBetBtn(parlayBets.legs) && lineChangeInfo.hasLineChange) {
          attention = {
            message: Constants.ATTENTION_MESSAGE.LINE_CHANGED,
            type: Constants.ATTENTION_TYPE.WARNING,
            display: 'left'
          };
        }
        break;
      case Constants.BET_ERROR_CODE.ROUND_ROBIN_DISALLOWED:
        parlayBets.legs.forEach(leg => leg.legStatus = Constants.BET_ERROR_CODE.ROUND_ROBIN_DISALLOWED);
        attention = {
          message: `errors:${Constants.BET_ERROR_CODE.ERROR3116}`,
          type: Constants.ATTENTION_TYPE.ERROR,
          display: 'left'
        };
        break;
      default:
        break;
    }

    // update round robin
    parlayBets.roundRobinOptions.forEach(roundRobin => {
      const updateRoundRobin = (roundRobinOptionWithOdds || []).find(rro => roundRobin.roundRobinOption === rro.roundRobinOption);
      if (updateRoundRobin) {
        roundRobin.odds = updateRoundRobin.odds;
        roundRobin.unroundedDecimalOdds = updateRoundRobin.unroundedDecimalOdds;
        parlayBets.odds = BetslipCommon.formatOddsValue(updateRoundRobin.odds, oddsFormat);
      }
    });

    if (!_.isEmpty(attention)) {
      dispatch(updateAttentionState(attention));
    }
    dispatch(updateParlayBetsState({ ...parlayBets }));
  };
}

const updateParlayLegsInfo = (invalidLegs, validLegs, parlayBets, lineChangeInfo) => {
  if (_.isEmpty(invalidLegs)) return false;
  parlayBets.legs.forEach(leg => {
    const invalidLeg = invalidLegs.find(invalidLeg => leg.legId === invalidLeg.legId) || {};
    const validLeg = (validLegs || []).find(validLeg => validLeg.legId === leg.legId) || {};
    if (!_.isEmpty(invalidLeg)) {
      switch (invalidLeg.errorCode) {
        case Constants.BET_ERROR_CODE.OFFLINE_EVENT:
        case Constants.BET_ERROR_CODE.INVALID_EVENT:
        case Constants.BET_ERROR_CODE.LINE_IS_NOT_AVAILABLE:
          leg.errorCode = Constants.BET_ERROR_CODE.EVENT_NOT_FOUND;
          break;
        case Constants.BET_ERROR_CODE.CORRELATED:
          leg.errorCode = Constants.BET_ERROR_CODE.CORRELATED;
          break;
        case Constants.BET_ERROR_CODE.LINE_CHANGED:
          leg.legStatus = Constants.ODDS_STATUS.ODDS_CHANGE;
          leg.oldOdds = leg.odds;
          leg.odds = invalidLeg.price;
          lineChangeInfo.hasLineChange = true;
          break;
        default:
          leg.errorCode = invalidLeg.errorCode;
          break;
      }
    }

    if (!_.isEmpty(validLeg)) {
      leg.oldOdds = leg.odds;
      leg.odds = validLeg.price;
      leg.status = validLeg.status;
    }
  });
}

export const executePlaceHRParlayBets = () => async (dispatch, getState) => {
  const parlayBets = getState().ParlayBetslipSlice.parlayBets;
  const parlayStake = getState().ParlayBetslipSlice.parlayStake;
  const {oddsFormat} = getState().SportsSlice.options;
  let legs = parlayBets.legs;
  const token = localStorage.getItem('token-user');
  const payload = BetslipHelper.buildPlaceHRParlayBetPayload(parlayBets.legs, WinRiskType.RISK, parlayStake, oddsFormat);
  dispatch(updateLoadingState(true));
  let res = null;
  try {
    res = await BetslipAction.submitHorseRacingPlaceBets(payload, token, window.env.enableRacebookDomainConfig, window.env.racebookDomain).then(res => {
      dispatch(updateLoadingState(false));
      return res
    });
  } catch (e) {
    dispatch(openAlert({
      message: 'errors:' + Constants.BET_ERROR_CODE.INTERNAL_ERROR
    }));
    dispatch(updateLoadingState(false));
    return
  }
  if (!res) {
    dispatch(openAlert({
      message: 'errors:' + Constants.BET_ERROR_CODE.INTERNAL_ERROR
    }));
    dispatch(updateLoadingState(false));
    return
  }
  if (res.status === 200 && res.data) {
    const data = res.data;
    data && data.forEach(item => {
      const {bets, betConfirmStatus, message, updatedPrices, errorCode} = item;
      if (betConfirmStatus === 'FAIL') {
        if(errorCode === Constants.HR_BET_STATUS.INVALID_SELECTION) {
          const matchingLegs = [...parlayBets.legs];
          legs = matchingLegs.map(bet => ({
            ...bet,
            status: Constants.HR_BET_STATUS.INVALID_SELECTION,
          }))
        } else {
          const tmp = {
            message: 'errors:' + message,
        }
        dispatch(openAlert(tmp))
        }
      }
  
      const successLegs = [];
      bets && bets.forEach(bet => {
        const {
          reason,
          winAmount,
          riskAmount,
          wagerId,
          ext,
          status,
          betType,
          meetingId,
          raceNumber,
          runnerNumber,
          limit
        } = bet;
        const betIndex = legs.findIndex(item => {
          const resOddsId = BetslipHelper.buildHROddsId(bet);
          return item.oddsId === resOddsId;
        });
        if (betIndex >= 0) {
          const matchingBet = legs[betIndex];
          const placedBet = {
            ...matchingBet,
            status,
            reason,
            wagerId,
            winAmount,
            riskAmount,
            limit
          };
          switch (status) {
            case Constants.HR_BET_STATUS.REJECTED:
              if (reason === Constants.HR_BET_REASON.PRICE_CHANGED) {
                placedBet.status = Constants.HR_BET_STATUS.PRICE_CHANGED;
                const changedId = `${betType}_${meetingId}_${raceNumber}_${runnerNumber}`;
                const {odds, userOdds} = updatedPrices[changedId];
                if (userOdds) {
                  placedBet.oldDisplayOdds = placedBet.odds;
                  placedBet.oddsDisplay = userOdds;
                }
                if (odds) {
                  placedBet.odds = odds;
                }
                placedBet.priceChanged = reason === Constants.HR_BET_REASON.PRICE_CHANGED;
                placedBet.betSlipEmit = {...placedBet.betSlipEmit, odds, userOdds};
              } else if (ext) {
                const tmp = {
                  message: 'errors:' + ext.errorCode,
                }
                dispatch(openAlert(tmp));
              } else {
                placedBet.status = status;
                placedBet.reason = (reason === Constants.HR_BET_REASON.EVENT_CLOSED ? Constants.UNAVAILABLE_MESSAGE : reason);
              }
              break;
            case Constants.HR_BET_STATUS.ACCEPTED:
              placedBet.externalBetId = ext.externalBetId;
              postMessageToHRIframe(Constants.HR_MESSAGE.ODDS_SELECTION, EMPTY_ARRAY);
              successLegs.push(placedBet);
              break;
            case Constants.HR_BET_STATUS.PARTIAL:
              break;
            default: break;
          }
          legs = legs.map(updatedBet => updatedBet.oddsId === placedBet.oddsId ? placedBet : updatedBet);
          dispatch(updateHRParlayLeg(placedBet));
        }
      });
      const acceptedParlayBets = {};
      if (successLegs.length) {
        const {winAmount, riskAmount, externalBetId} = successLegs[0];
        acceptedParlayBets.status = Constants.BET_STATUS.ACCEPTED
        acceptedParlayBets.acceptedBets = successLegs;
        acceptedParlayBets.oddsDisplay = Number(parlayBets.odds ? parlayBets.odds.toString().replaceAll(Constants.THOUSANDS_SEPARATOR, ''): 0);
        acceptedParlayBets.winAmount = winAmount;
        acceptedParlayBets.riskAmount = riskAmount;
        acceptedParlayBets.externalBetId = externalBetId;
        acceptedParlayBets.legs = legs;
        acceptedParlayBets.isRBParlay = true;
        dispatch(updateHRBetslipItems(successLegs));
        reloadBalanceAndPendingBets()
      }
      batch(() => {
        dispatch(updateParlayBetSuccessResState(acceptedParlayBets))
        dispatch(updatePlaceSingleBetsSuccessState())
        dispatch(updatePlaceParlayBetsSuccessState())
        dispatch(updateParlayBetsState({...parlayBets, legs}));
        dispatch(updateRBCurrentOddsFormatState(oddsFormat))
      })
    })
    
  } else {
    dispatch(openAlert({
      message: 'errors:' + Constants.BET_ERROR_CODE.INTERNAL_ERROR
    }))
  }
}

// do not use temporarily
const updateParlayTicket = (parlayBets, oddsFormat) => {
  return async (dispatch, getState) => {
    const { ticketId, legs } = parlayBets
    const params = BetslipHelper.buildParlayUpdateTicketPayload(ticketId, oddsFormat, legs)
    let msgCode
    BetServices.updateParlayTicket(params).then(res => {
      if (res) {
        const { updatedTickets } = res.data
        const updatedLegs = legs.map(leg => {
          const updateData = {}
          const matchedLeg = updatedTickets.filter(l => l.legId === leg.legId)[0] || {}
          if (_.isEmpty(matchedLeg)) return leg;
          const { odds, status } = matchedLeg;
          if (status) {
            updateData.status = status
            switch (status) {
              case Constants.BET_ERROR_CODE.ODDS_CHANGE:
                if (Number(odds) !== Number(leg.odds)) {
                  updateData.errorCode = null
                  updateData.oldOdds = leg.odds
                  updateData.odds = odds
                  msgCode = Constants.BET_ERROR_CODE.BET_LINE_CHANGED
                }
                break
              case Constants.BET_ERROR_CODE.UNAVAILABLE:
                updateData.errorCode = Constants.UNAVAILABLE_MESSAGE
                break
              case Constants.BET_ERROR_CODE.LINE_CHANGED:
                updateData.errorCode = Constants.BET_ERROR_CODE.LINE_CHANGED
                break
              default:
                updateData.errorCode = null
            }
          }
          if (matchedLeg.errorCode === Constants.BET_ERROR_CODE.LINE_CHANGED) {
            msgCode = Constants.BET_ERROR_CODE.LINE_CHANGED
          }
          return { ...leg, ...updateData }
        })
        dispatch(updateParlayBetsState({ ...parlayBets, legs: updatedLegs }))
        return msgCode
      }
    })
  }
}

export const changeRROs = (event, rro) => {
  return (dispatch, getState) => {
    const selectedRROs = JSON.parse(JSON.stringify(getState().ParlayBetslipSlice.selectedRROs))
    if (event.target.checked) {
      selectedRROs.push(rro)
    } else {
      const index = selectedRROs.indexOf(rro)
      if (index > -1) {
        selectedRROs.splice(index, 1)
        }
      }
      dispatch(updateSelectedRROsState(selectedRROs))
    }
  }

  export const removeParlayBetSuccess = (roundRobinOption) => {
    return (dispatch, getState) => {
      const newState = JSON.parse(JSON.stringify(getState().ParlayBetslipSlice.parlayBetsSucessRes))
      const { options } = getState().SportsSlice
      if (newState.acceptedBets.length === 1) {
        dispatch(updateParlayBetSuccessResState(EMPTY_OBJECT))
        dispatch(changeButton(BetslipHelper.getButtonSelection(options.isTopLeague, options.favourite)))
      } else {
        const acceptedBets = newState.acceptedBets.filter(bet => {
          return bet.roundRobinOption !== roundRobinOption
        })
        if (acceptedBets.length > 0) {
          newState.acceptedBets = acceptedBets
          dispatch(updateParlayBetSuccessResState(newState))
        }
      }
      
    }
  }

  export const removeAllParlayBets = () => {
    return async (dispatch, getState) => {
      const { options } = getState().SportsSlice
      batch(() => {
        dispatch(updatePlaceSingleBetsSuccessState())
        dispatch(updatePlaceParlayBetsSuccessState())
        dispatch(updateConfirmationRemoveState(false))
        dispatch(updatePitchersState(EMPTY_OBJECT))
        dispatch(changeButton(BetslipHelper.getButtonSelection(options.isTopLeague, options.favourite)))
        postMessageToHRIframe(Constants.HR_MESSAGE.ODDS_SELECTION, []);
        dispatch(updateHRBetslipItems(EMPTY_ARRAY));
        dispatch(updateHRSingleBetsState(EMPTY_ARRAY));
      })     
    }
  }
  
  export const removeParlayBetItem = (legId) => {
    return async (dispatch, getState) => {
      const {oddsSelection, singleBets, pitchers, attention, selectedBetslipTab} = getState().BetslipSlice
      const {
        hrBetslipItemList,
      } = getState().HRBetslipSlice;
      const {parlayOddsRequest, parlayBets} = getState().ParlayBetslipSlice
      const {options} = getState().SportsSlice
      const newPitchers = JSON.parse(JSON.stringify(pitchers))
      const rbParlayLegs = parlayBets.legs && parlayBets.legs.filter(bet => bet.sportId === Constants.HORSE_RACING_ID);
      if (oddsSelection.length + hrBetslipItemList.length === 1 && parlayOddsRequest.parlayOddsRequest.parlayOddsSelections.length === 1) {
        batch(() => {
          dispatch(updatePlaceSingleBetsSuccessState())
          dispatch(updatePlaceParlayBetsSuccessState())
          dispatch(updateConfirmationRemoveState(false))
          dispatch(updatePitchersState(EMPTY_OBJECT))
          dispatch(changeButton(BetslipHelper.getButtonSelection(options.isTopLeague, options.favourite)))
        })
        
      } else {
        const leg = parlayBets.legs.filter(leg => {
          return leg.legId === legId
        })
        if (leg.length > 0) {
          const selectionId = leg[0].selectionId
          if (pitchers[selectionId]) {
            delete pitchers[selectionId]
          }
        }
        let payload = JSON.parse(JSON.stringify(parlayOddsRequest)) 
        const { parlayOddsSelections } = payload.parlayOddsRequest
        const parlayOdds = parlayOddsSelections.filter((odds, index) => {
          return odds.legId !== legId
        })
        if (parlayOdds.length > 0) {
          payload.parlayOddsRequest.parlayOddsSelections = parlayOdds
          const response =  await BetServices.parlayRemoveSelection(payload, legId).then(res => {
            return res.data;
          }).catch(e => {
          });
          batch(() => {
            dispatch(updateParlayOddsRequestState(payload))
            dispatch(updateSelectedRROsState([RoundRobinOption.PARLAY]));
            if (!BetslipHelper.isDefaultAttention(attention, selectedBetslipTab)) {
              dispatch(updateShowAttentionState(false));
              dispatch(resetAttentionState());
            }
            if (BetslipHelper.isOddsChangeOnLegs(response.legs)) {
              const updatedRes = JSON.parse(JSON.stringify(response))
              updatedRes.legs = BetslipHelper.addOldOddsForLegs(oddsSelection, payload, updatedRes.legs)
              const updatedParlayBets  =  rbParlayLegs && rbParlayLegs.length > 0 ? {...updatedRes, legs: [...updatedRes.legs, ...rbParlayLegs]} : updatedRes;
              dispatch(updateParlayBetsState(updatedParlayBets))
            } else {
              const resParlayBets  =  rbParlayLegs && rbParlayLegs.length > 0 ? {...response, legs: [...response.legs, ...rbParlayLegs]} : response;
              dispatch(updateParlayBetsState(resParlayBets))
            }
          })
        } else {
          if(rbParlayLegs && rbParlayLegs.length > 0) {
            const legs = parlayBets.legs.filter(leg => leg.legId !== legId)
            dispatch(updateParlayBetsState({...parlayBets, legs}))
          } else {
            dispatch(updatePlaceParlayBetsSuccessState())
          }
        }
        const oddsId = BetslipHelper.getOddsIdByLegId(oddsSelection, parlayOddsRequest, legId)
        const selection = oddsSelection.filter((selection, index) => {
          return selection.oddsId !== oddsId
        })
        const bets = singleBets.filter((bet, index) => {
          return (bet.oddsId !== oddsId && bet.sportId !== Constants.HORSE_RACING_ID) || bet.sportId === Constants.HORSE_RACING_ID
        })

        batch(() => {
          dispatch(updateOddsSelectionState(selection))
          dispatch(updateSingleBetsState(bets))
          const stakeInputs = Object.assign({}, getState().BetslipSlice.stakeInputs)
          const minMaxBets = Object.assign({}, getState().BetslipSlice.minMaxBets)
          if (stakeInputs[oddsId]) {
            delete stakeInputs[oddsId]
            delete minMaxBets[oddsId]
            dispatch(updateStakeInputsState(stakeInputs))
            dispatch(updateMinMaxBetState(minMaxBets))
            dispatch(updatePlaceBetInfo())
          }
          if (pitchers[oddsId]) {
            delete newPitchers[oddsId]
          }
          dispatch(updatePitchersState(newPitchers))
        })

      }
    }
  }

export const removeHRParlayBetItem = (legId) => (dispatch, getState) => {
  const {parlayBets} = getState().ParlayBetslipSlice;
  const hrBetslipItemList = getState().HRBetslipSlice.hrBetslipItemList;
  const {options} = getState().SportsSlice
  if (parlayBets.legs.length === 1) {
    batch(() => {
      dispatch(updatePlaceSingleBetsSuccessState())
      dispatch(updateHRBetslipItems([]));
      dispatch(updatePlaceParlayBetsSuccessState())
      dispatch(updateConfirmationRemoveState(false))
      dispatch(updatePitchersState(EMPTY_OBJECT))
      dispatch(changeButton(BetslipHelper.getButtonSelection(options.isTopLeague, options.favourite)))
    });
    postMessageToHRIframe(Constants.HR_MESSAGE.ODDS_SELECTION, []);
  } else {
    let legs = parlayBets.legs.filter(leg => leg.legId !== legId);
    const removedLeg = parlayBets.legs.find(bet => bet.legId === legId);
    const correlatedLegs = legs.filter(bet => bet.raceNumber === removedLeg.raceNumber && bet.meetingId === removedLeg.meetingId);
    if (correlatedLegs && correlatedLegs.length > 0) {
      const betLegs = BetslipHelper.updatedCorrelatedLegs(correlatedLegs);
      legs = legs.map(leg => betLegs.find(betLeg => leg.legId === betLeg.legId) || leg);
    }
    const roundRobinOptions = parlayBets.roundRobinOptions[0]
    const updatedParlayBets = {
      ...parlayBets,
      roundRobinOptions: [{
        ...roundRobinOptions,
        rroLegs: legs.length,
        totalLegs: legs.length,
      }],
      legs
    };
    const existingRbLegs = legs.filter(leg => leg.sportId === Constants.HORSE_RACING_ID).map(item => item.betSlipEmit)
    postMessageToHRIframe(Constants.HR_MESSAGE.ODDS_SELECTION, existingRbLegs || []);
    dispatch(updateParlayBetsState(updatedParlayBets));
    dispatch(updateHRBetslipItems(hrBetslipItemList.filter(bet => bet.oddsId !== legId)));
    if(legs && legs.some(leg => leg.sportId === Constants.HORSE_RACING_ID && leg.legId !== legId)) {
      dispatch(getHRParlayLimitBet());
    }
  }
}

  export const updatePitcherParlay = (params) => {
    return async (dispatch) => {
      try {
        const response =  await BetServices.updatePitcherParlay(params).then(res => {
          return response.data
        }).catch(e => {
          dispatch(updatePitcherParlayFailure());
        });
        dispatch(updatePitcherParlaySuccess())
      } catch (error) {
        dispatch(updatePitcherParlayFailure())
      }
    }
  }

export const checkInvalidStake = (stake) => {
  return (dispatch) => {
    let disable = !stake || stake == 0
    dispatch(updateInvalidStake(disable))
  }
}

export const getHRParlayLimitBet = (isRefresh, isChangedOddsType) => (dispatch, getState) => {
  const parlayBets = getState().ParlayBetslipSlice.parlayBets;
  const rbParlayLegs = parlayBets.legs && parlayBets.legs.filter(bet => bet.sportId === Constants.HORSE_RACING_ID);
  if (parlayBets.legs && parlayBets.legs.length > 1 && rbParlayLegs && rbParlayLegs.length > 1) {
    const oddsFormat = getState().SportsSlice.options.oddsFormat;
    const betsToGetLimit = BetslipHelper.buildGetParlayLimitPayload(rbParlayLegs, oddsFormat);
    isRefresh && dispatch(updateLoadingState(true));
    BetServices.getLimitBet(betsToGetLimit).then(res => {
      if(res && res.data && res.data[0]) {
        const {id, minRisk, minWin, maxRisk, maxWin, totalOdds, latestOdds, message} = res.data[0];
        if (id) {
          parlayBets.legs.forEach(bet => {
            const matchBet = latestOdds.find((item) =>
                `${bet.raceNumber}-${bet.meetingId}-${bet.runnerNumber}` === `${item.raceNumber}-${item.meetingId}-${item.runnerNumber}`
            )
            if (matchBet) {
              const price = matchBet.price;
              const newDisplayOdds = price[bet.betType.toLowerCase()];
              const newOdds = price[`${bet.betType.toLowerCase()}Decimal`];
              const updatedBet = {...bet};
              if (newDisplayOdds && bet.odds !== newOdds && !bet.status) {
                updatedBet.oldDisplayOdds = updatedBet.odds;
                updatedBet.status = !isChangedOddsType ? Constants.HR_BET_STATUS.PRICE_CHANGED : null;
              }
              updatedBet.odds = newOdds;
              updatedBet.oddsDisplay = newDisplayOdds;
              updatedBet.betSlipEmit = {...updatedBet.betSlipEmit, odds: newOdds, userOdds: newDisplayOdds};
              dispatch(updateHRParlayLeg(updatedBet));
            }
          })
          const updatedTotalOdds = BetslipCommon.convertOddsByOddsFormat(BetslipCommon.convertStakeToNumber(totalOdds), OddsFormat.Decimal, oddsFormat)
          const updatedParlayBets = {
            maxRiskStake: maxRisk,
            maxWinStake: maxWin,
            minRiskStake: minRisk,
            minWinStake: minWin,
            totalOdds,
            odds: updatedTotalOdds,
          };
          dispatch(updateMinMaxHRParlayBet(updatedParlayBets));
        } else {
          dispatch(openAlert({
            message
          }))
        }
      }
      isRefresh && dispatch(updateLoadingState(false));
    });
  }
}

export const updateParlayPendingBetsToAcceptedBets = (bets) => {
  return (dispatch, getState) => {
    const acceptedBetsRes = JSON.parse(JSON.stringify(getState().ParlayBetslipSlice.parlayBetsSucessRes));
    const {
      pendingBets,
      roundRobinOptions,
      legs
    } = acceptedBetsRes;

    const usedMasterId = pendingBets && pendingBets.length > 0;
    // Filter the bets array from my-bets service by status, then filter the result by betId and rroLegs.
    const filterByStatus = (bets, pendingBet, status) => {
      return bets
        .filter(bet => bet[wagerMap.status] === status)
        .filter(bet => pendingBet.betId === bet[
          usedMasterId 
            ? wagerMap.masterWagerId
            : wagerMap.wagerId
        ])
        .filter(bet => pendingBet.rroLegs === bet[wagerMap.wagerSelections].length);
    }

    if (pendingBets) {
      // accepted bets
      const acceptedBets = pendingBets
        .map(pendingBet => {
          const acceptedFilter = filterByStatus(bets, pendingBet, Constants.WAGER_STATUS.OPEN);
          if (acceptedFilter.length > 0) {
            roundRobinOptions[0].odds = acceptedFilter.reduce((odds, bet) => {
              return odds + BetslipCommon.convertStakeToNumber(bet[WagerMyBetMap.odds]);
            }, 0);
            acceptedFilter[0][WagerMyBetMap.wagerSelections].forEach(item => {
              const legIndex = legs.findIndex(leg => leg.eventId === item[wagerSelectionMap.eventId]);
              if (legIndex < 0) return;
              legs[legIndex].odds = item[wagerSelectionMap.odds];
              legs[legIndex].handicap = item[wagerSelectionMap.handicap];
            });
            return {
              ...pendingBet,
              status: Constants.STATUS_BET.ACCEPTED,
              risk: acceptedFilter.reduce((totalRisk, bet) => {
                return totalRisk + BetslipCommon.convertStakeToNumber(bet[WagerMyBetMap.toRisk]);
              }, 0),
              win: acceptedFilter.reduce((totalWin, bet) => {
                return totalWin + BetslipCommon.convertStakeToNumber(bet[WagerMyBetMap.toWin]);
              }, 0),
            }
          }
          return null;
        })
        .filter(pendingBet => pendingBet);
      
      // getting rejected bets if there are no accepted bets
      const rejectedBets = acceptedBets.length === 0 
        ? pendingBets
            .map(pendingBet => {
              const rejectedFilter = filterByStatus(bets, pendingBet, Constants.WAGER_STATUS.CANCELLED);
              if (rejectedFilter.length > 0) {
                return {
                  ...pendingBet,
                  status: Constants.BET_STATUS.PROCESSED_WITH_ERROR
                };
              }
              return null;
            })
            .filter(pendingBet => pendingBet)
        : [];
      
      if (acceptedBets.length > 0) {
        // update from pendingBets to acceptedBets
        acceptedBetsRes.status = Constants.STATUS_BET.ACCEPTED;
        acceptedBetsRes.acceptedBets = acceptedBets;
        delete acceptedBetsRes['pendingBets'];
        dispatch(updateParlayBetSuccessResState(acceptedBetsRes));
      }

      if (rejectedBets.length > 0) {
        // update from pendingBets to rejectedBets
        acceptedBetsRes.status = Constants.STATUS_BET.PROCESSED_WITH_ERROR;
        acceptedBetsRes.acceptedBets = rejectedBets;
        delete acceptedBetsRes['pendingBets'];
        dispatch(updateParlayBetSuccessResState(acceptedBetsRes));
      }

      if(acceptedBets.length > 0 || rejectedBets.length > 0) {
        GA4Common.sendEventGA(GA_EVENT.BET_SLIP_LIVE_ACCEPTANCE, {tab: BETSLIP_TABS.PARLAY});
      }
    }
  }
}

/** END */
export const parlayBetslipSelector = state => state.ParlayBetslipSlice
export default ParlayBetslipSlice.reducer;


// WEBPACK FOOTER //
// ./src/app/slices/ParlayBetslipSlice.js